import React from 'react';
import './WhyUs.css';

const reasons = [
  {
    number: '01',
    title: 'Transparent Pricing',
    description: "No hidden fees or surprise invoices. We agree on clear terms upfront, so you always know what you're paying for.",
  },
  {
    number: '02',
    title: 'Every Candidate Is Pre-Vetted',
    description: "We don't send you a stack of resumes to sort through. Every candidate goes through our multi-step screening — skills, culture fit, references, and motivation.",
  },
  {
    number: '03',
    title: 'We Actually Listen',
    description: "We take the time to understand your team, your culture, and what 'the right hire' really means for your business — not just fill a seat.",
  },
  {
    number: '04',
    title: 'Replacement Guarantee',
    description: "If a placement doesn't work out, we'll find a replacement at no extra cost. We stand behind every hire we make.",
  },
];

const WhyUs: React.FC = () => {
  return (
    <section className="whyus">
      <div className="whyus__container">
        <div className="whyus__left">
          <span className="whyus__tag">Why Us</span>
          <h2 className="whyus__title">
            What Makes Us<br />
            <span className="whyus__title--accent">Different</span>
          </h2>
          <p className="whyus__desc">
            Hiring the wrong person is expensive. Hiring too slowly costs you momentum.
            We're here to help you get it right the first time.
          </p>
          <div className="whyus__cta-box">
            <div className="whyus__cta-text">
              <strong>Ready to stop losing candidates?</strong>
              <span>Book a free consultation — no strings attached.</span>
            </div>
            <button className="whyus__cta" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
              Get Started →
            </button>
          </div>
        </div>
        <div className="whyus__right">
          {reasons.map((reason, i) => (
            <div className="whyus__card" key={i}>
              <span className="whyus__card-number">{reason.number}</span>
              <div>
                <h3 className="whyus__card-title">{reason.title}</h3>
                <p className="whyus__card-desc">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
